import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { ProductGroupBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { ProductGroupModel } from '@skylab-shared/dataModel';

import { ProductGroupRepository, ProductGroupRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface ProductGroupDialogResult {
    externalId: string;
    version: string;
}

interface ProductGroupDialogViewModel extends DictionaryDialogViewModelBase<ProductGroupBO> {
    wasDefault: boolean;
}
@Component({
    selector: 'skl-product-group-dialog',
    templateUrl: './product-group-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, BooleanValueAccessorDirective, FormsModule, ValidateDirective, TextValueAccessorDirective, FocusByDirective, ButtonComponent, TranslatePipe]
})
export class ProductGroupDialogComponent extends DictionaryDialogComponentBase
<
ProductGroupModel,
ProductGroupBO,
ProductGroupRepositoryBase,
ProductGroupDialogViewModel
> {
    public constructor(
        @Inject(ProductGroupRepository) productGroupRepositoryBase: ProductGroupRepositoryBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(EventBus) eventBus: EventBusBase,
        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(productGroupRepositoryBase, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }

    protected override async prepareViewModelAsync(): Promise<void> {
        await super.prepareViewModelAsync();
        this.viewModel.wasDefault = false;
    }

    protected override async prepareDataAsync(): Promise<void> {
        await super.prepareDataAsync();
        this.viewModel.wasDefault = this.viewModel.bo.model.isDefault;
    }
}
